import { getAccessToken } from 'buzz_lib_shared';
export class UserApi {
  constructor() {
    let endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'https://buzzauthdevelop.azurewebsites.net';
    this.endpoint = endpoint;
  }
  async getUserGroups(userId) {
    const requestUrl = "".concat(this.endpoint, "/api/user_groups?userId=").concat(userId);
    const response = await fetch(requestUrl, {
      headers: await this.getHeaders()
    });
    const groups = await response.json();
    return groups !== null && groups !== void 0 ? groups : [];
  }
  async getUserMail(userId) {
    const requestUrl = "".concat(this.endpoint, "/api/user_mail?userId=").concat(userId);
    const response = await fetch(requestUrl, {
      headers: await this.getHeaders()
    });
    const mailResponse = await response.text();
    const mail = !isEmptyResponseString(mailResponse) ? mailResponse : '';
    return mail;
  }
  async getHeaders() {
    const accessToken = await getAccessToken();
    return {
      Authorization: "Bearer ".concat(accessToken)
    };
  }
}
const isEmptyResponseString = responseString => responseString === '{}';